import api from './api';
import { toast } from 'react-toastify';
import convertOptions from '../util/convertOptions';

export const getEstados = async (convertParam, raw) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get('/cep/estados');

    return raw ? data : convertOptions(data, convertParam || 'Uf', 'Uf');
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados.');
    return [];
  }
};

export const getCidades = async (idEstado, valuesUpperCase = false) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(`/cep/cidades/${idEstado}`);

    let cidades = convertOptions(data, 'Nome', 'Nome');

    if(valuesUpperCase) {
      cidades = cidades.map(cidade => {
        cidade.value = cidade.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
        return cidade
      })
    }

    return cidades
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados.');
    return [];
  }
};

export const consultaCep = async (cep, uf = false) => {
  try {
    const client = await api('consulta');
    const { data } = await client.get(`/cep`, { params: { cep } });

    if(uf) data.uf = data.estado
    
    return data;
  } catch (error) {
    toast.error('Ocorreu um erro ao tentar carregar os dados.');
    return [];
  }
};
